import { AxiosRequestConfig } from "axios";

export const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_URL,
};

export const configBlob: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_URL,
};

export const uncachedConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_URL,
};
